import { useState } from "react";
import { useContext } from "../../../../context";

export function useSubmit() {
  const {
    refetchAppointments,
    modals: {
      fee: { close },
    },
  } = useContext();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit =
    (cb) =>
    async (...args) => {
      setIsSubmitting(true);

      try {
        await cb(...args);
      } finally {
        setIsSubmitting(false);
        refetchAppointments();
        close();
      }
    };

  return {
    isSubmitting,
    submit,
  };
}
